import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function PaymentsIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <rect x="30" y="36" width="100" height="68" rx="12" fill={c.p500} />
      <rect x="30" y="50" width="100" height="12" fill={c.p700} />
      <rect x="70" y="72" width="20" height="14" rx="3" fill={c.a300} />
      <circle cx="80" cy="108" r="18" fill={c.s500} stroke={c.n0} strokeWidth="4" />
      <path d="M71 108l6 6 12-13" stroke={c.n0} strokeWidth="4" />
    </Frame>
  );
}
